/* global site: false, __: false, app: true, win: true, urlParams: false, pad: false, Vimeo: false, grecaptcha: false */
if(sessionStorage.getItem('alert-hidden')){
	$('#alert-message').hide();
}

$('#backdrop').removeAttr('style');

/**
 * resizes the banner videos to be centered at all screen sizes
 * @return {function} returns istelf to be used in event listeners
 */

$(document).ready(function(){
	app.head = $('header#main-header');
	app.headHeight = app.head.outerHeight();
	app.banner = $('#hero-banner');
	app.scrollToTop = $('#scroll-to-top');
	app.mediaBreaks = {
		phone_small: 395,
		phone: 600,
		tablet: 1024,
		laptop: 1366,
		desktop: 1770
	};

	app.toggleFaq = function(scope){
		var that = $(scope);

		that.closest('.row, li').siblings().find('.answer, .copy').slideUp();
		that.closest('.row, li').siblings().find('h6').removeClass('open');
		that.toggleClass('open');
		that.nextAll('.answer, .copy').slideToggle().promise().done(function(){
			// scrollTo(scope, 1000, 100);
		});
	};

	$('.question h6').click(function(){
		app.toggleFaq(this);
	});

	$('.question h6').on('focus', function(){
		var that = this;

		$(that).on('keydown', function(e){
			if(e.which === 32 || e.which === 13){
				app.toggleFaq(that);
			}
		});
	}).on('blur', function(){
		var that = this;

		$(that).off('keydown');
	});

	$('.close-alert-button').click(function(e){
		var alertBar = $('#alert-message'),
			alertBarInner = $('.alert-message-inner');

		e.preventDefault();

		sessionStorage.setItem('alert-hidden', 'true');
		alertBarInner.slideUp();
		alertBar.animate({height: 0}).promise().done(function(){
			alertBar.remove();
			app.headHeight = app.head.outerHeight();
		});
	});

	/**
	 * Add and removes the hasValue class from inputs for label position
	 */
	$('input, textarea').each(function(){
		var that = $(this);

		if(that.val()){
			that.addClass('hasValue');
			that.nextAll('.clear-input').click(function(e){
				that.val('');
				that.removeClass('hasValue');
				that.nextAll('.typeahead-results').html('<div class="no-results">' + __('Start typing to search.', 'halekulani_domain') + '</div><span class="error"></span>');
			});
		}
	}).on('blur', function(){
		var that = $(this);

		if(that.val()){
			that.addClass('hasValue');
			that.nextAll('.clear-input').click(function(e){
				that.val('');
				that.removeClass('hasValue');
				that.nextAll('.typeahead-results').html('<div class="no-results">' + __('Start typing to search.', 'halekulani_domain') + '</div><span class="error"></span>');
			});
		}else{
			that.removeClass('hasValue');
		}
	});

	/**
	 * Changes the language in a ~~super~~ much less jank way.
	 */
	$('#language-switcher').change(function(e){
		var that = $(this);

		window.location = $('link[hreflang="' + that.val() + '"]').attr('href');
	});

	/**
	 * From submition for login
	 */
	$('#footer-login').submit(function(e){
		var that = $(this);

		e.preventDefault();
		that.find('button[type="submit"]').prop('disabled', true);
		app.doLogin(urlParams(that.serialize()), function(data){
			if(data.status && data.status > 0){
				that.removeClass('show');
				$('#footer-username').html(__('Welcome Back %s!', data.name, 'halekulani_domain'));
				$('#footer-logout button').removeAttr('tabindex');
				$('#footer-login button').attr('tabindex', '-1');
				$('#footer-logout').addClass('show');
				$('nav[role="navigation"] ul').append('<li><a href="' + site.url + '/users/' + data.cleanName + '" title="' + __('My Page', 'halekulani_domain') + '">' + __('My Page', 'halekulani_domain') + '</a></li>');
			}

			that.find('button[type="submit"]').removeAttr('disabled');
		});
	});

	/**
	 * From submition for logout
	 */
	$('#footer-logout').submit(function(e){
		var that = $(this);

		e.preventDefault();
		that.find('button[type="submit"]').prop('disabled', true);
		app.doLogout(urlParams(that.serialize()), function(data){
			if(data.status && data.status > 0){
				that.removeClass('show');
				$('#footer-login button').removeAttr('tabindex');
				$('#footer-logout button').attr('tabindex', '-1');
				$('#footer-login').addClass('show');
				location.reload();
			}

			that.find('button[type="submit"]').removeAttr('disabled');
		});
	});

	/**
	 * Creates the signup modal and from submition for the signup
	 */
	$('#footer-signup-link').click(function(e){
		e.preventDefault();

		app.makeModals('signup-modal');
		app.modalContent.load(site.theme.uri + '/views/signup.twig' + '?_=' + (new Date()).getTime(), function(){
			$('#footer-signup input#user_signup_email').focus();
			$('#footer-signup input').on('blur', function(){
				if($(this).val()){
					$(this).addClass('hasValue');
				}else{
					$(this).removeClass('hasValue');
				}
			});

			$('#footer-signup').submit(function(e){
				var that = $(this);

				e.preventDefault();
				that.find('button[type="submit"]').prop('disabled', true);
				app.doSignup(urlParams(that.serialize()), function(data){
					if(data.status && data.status > 0){
						$('#footer-login').removeClass('show');
						$('#footer-username').html(__('Welcome Back %s!', data.name, 'halekulani_domain'));
						$('#footer-logout').addClass('show');
						$('nav[role="navigation"] ul').append('<li><a href="' + site.url + '/users/' + data.cleanName + '" title="My Page">My Page</a></li>');
						app.modalClose();
					}

					that.find('button[type="submit"]').removeAttr('disabled');
				});
			});
		});
	});

	/**
	 * Creates the image modal. Currently works on img tags with class modal-img.
	 * the data-target att on the img should be a link to the full size image. if no target is provided, the src is used
	 */

	$('img.modal-img').click(function(e){
		console.log('clicking');
		var caption = $(this).nextAll('meta[name="caption"]') ? $(this).nextAll('meta[name="caption"]').attr('content') : null;
		var title = $(this).nextAll('meta[name="title"]') ? $(this).nextAll('meta[name="title"]').attr('content') : null;

		e.preventDefault();
		app.modalImg(this, caption, title);
	});

	$('img.modal-img').on('focus').on('keypress', function(e){
		if(e.which === 32){
			var caption = $(this).nextAll('meta[name="caption"]') ? $(this).nextAll('meta[name="caption"]').attr('content') : null;
			var title = $(this).nextAll('meta[name="title"]') ? $(this).nextAll('meta[name="title"]').attr('content') : null;

			e.preventDefault();
			app.modalImg(this, caption, title);
		}
	});

	$('a.modal-img').click(function(e){
		var title = $(this).data('title') || null,
			caption = $(this).data('caption') || null;

		e.preventDefault();
		app.modalImg(this, caption, title);
	});

	/**
	 * Creates an ajax modal. Currently works on anchor tags with class modal-ajax and pulls out the data-target attr.
	 * that attr should be a class/id/attr on the target page. if no data-target is present, the role="main" content is used
	 */
	$('a.modal-ajax').click(function(e){
		var url = $(this).attr('href') + '?modal',
			target = $(this).attr('data-target') || 'article[role="article"]';

		e.preventDefault();
		app.makeModals('content-modal');
		$.get(url, function(data){
			if($(data).find(target).length){
				app.modalContent.html($(data).find(target));
			}else{
				app.modalContent.html($(data).find('article[role="article"]'));
			}

			app.observeIntersections(app.modal[0]);
		});
	});

	$('a.modal-opentable').click(function(e){
		var iframe = document.createElement('iframe');

		e.preventDefault();
		iframe.src = $(this).attr('href');
		iframe.width = 224;
		iframe.height = 301;
		iframe.setAttribute('title', __('Book a table with OpenTable', 'halekulani_domain'));
		iframe.setAttribute('frameborder', 0);
		iframe.setAttribute('autoplay', 1);
		iframe.setAttribute('allowfullscreen', 1);

		app.makeModals('iframe-modal');
		app.modalContent.html(iframe);
		app.modal.css({
			'height': 301,
			'width': 224,
			'top': -150,
			'margin': '50vh auto 0'
		});
	});

	/**
	 * This makes the sidebar sticky, if it exists.
	 */
	if($('aside[role="complementary"]').length && $(window).width() > 980){
		var sidebarWrapper = $('aside[role="complementary"]'),
			stop = $('footer#main-footer'),
			wd, hi;

		app.sidebarInner = $('aside[role="complementary"] > div');

		app.moveSidebar = function(){
			if(win.scrollTop() >= sidebarWrapper.offset().top - 20 && app.sidebarInner.height() < win.height() - app.head.height()){
				wd = app.sidebarInner.width();
				hi = app.sidebarInner.height();
				sidebarWrapper.css('height', sidebarWrapper.height());
				app.sidebarInner.css({
					'position': 'fixed',
					'top': 20,
					'width': wd,
					'height': hi
				});
			}else{
				app.sidebarInner.removeAttr('style');
				sidebarWrapper.removeAttr('style');
			}

			if(win.scrollTop() + app.sidebarInner.height() >= stop.offset().top - 41){
				app.sidebarInner.css({
					'top': stop.offset().top - win.scrollTop() - hi - 21
				});
			}

			return app.sidebarInner.offset().top;
		};
	}

	$('nav#main-navigation ul ul a').focus(function(){
		var that = $(this);

		that.closest('ul').prev('a').addClass('child-has-focus');
	}).blur(function(){
		var that = $(this);

		that.closest('ul').prev('a').removeClass('child-has-focus');
	});

	$('.header-search-toggle').focus(function(e){
		var that = $(this),
			form = that.prev('form');

		if(that.hasClass('open')){
			that.removeClass('open');
			that.attr('tabindex', 0);
			that.blur();
			form.animate({'width': '0', 'padding-right': '0', 'padding-left': '0'});
		}else{
			that.addClass('open');
			that.attr('tabindex', -1);
			form.animate({'width': '96%', 'padding-right': '3em', 'padding-left': '1em'});
			form.find('[type="search"]').focus();
			$('nav#main-navigation > ul > li > a, nav#main-navigation > ul > li > span, #utility-navigation > ul > li > a').not(this).focus(function(){
				that.removeClass('open');
				that.attr('tabindex', 0);
				form.animate({'width': '0', 'padding-right': '0', 'padding-left': '0'});
			});
		}
	});

	$('#backdrop').on('display:toggle', function(){
		var backdrop = $(this);

		if(backdrop.is('.show')){
			backdrop.trigger('display:hide');
		}else{
			backdrop.trigger('display:show');
		}
	}).on('display:show', function(){
		var backdrop = $(this);

		backdrop.find('#modal').hide();
		backdrop.addClass('show no-modal');
		// $('body').addClass('no-scroll');
	}).on('display:hide', function(){
		var backdrop = $(this);

		// $('body').removeClass('no-scroll');
		backdrop.removeClass('show');
		setTimeout(function(){
			backdrop.removeClass('no-modal');
			backdrop.find('#modal').removeAttr('style');
		}, 300);
	});

	$('.mega-menu').on('display:toggle', function(){
		var megaMenu = $(this);

		if(megaMenu.is('.show')){
			megaMenu.trigger('display:hide');
		}else{
			megaMenu.trigger('display:show');
		}
	}).on('display:show', function(){
		var megaMenu = $(this);

		megaMenu.prev('span').addClass('open');
		megaMenu.addClass('show').css('top', $('#main-navigation').outerHeight() + (app.head[0].getBoundingClientRect().bottom - $('#main-navigation')[0].getBoundingClientRect().bottom));
	}).on('display:hide', function(){
		var megaMenu = $(this);

		megaMenu.prev('span').removeClass('open');
		megaMenu.removeClass('show');
	});

	$('nav#main-navigation .menu-item-has-children > span').each(function(){
		var that = $(this);
		var megaMenu = that.next('.mega-menu');

		that.on('click focus', function(e){
			if(e.type === 'click'){
				return false;
			}else if(e.type === 'focus'){
				$('nav#main-navigation .menu-item-has-children > span').off('mousedown');
				$('#backdrop').trigger('display:show');
				$('.mega-menu').trigger('display:hide');
				megaMenu.trigger('display:show');

				$('nav#main-navigation > ul > li > a, .header-search-toggle').on('focus', function(){
					$('#backdrop').trigger('display:hide');
					megaMenu.trigger('display:hide');
				});

				that.on('mousedown', function(){
					$('#backdrop').trigger('display:toggle');
					megaMenu.trigger('display:toggle');
				});

				win.on('click', function(evt){
					if(!$(evt.target).parents('.mega-menu').is(megaMenu) && !$(evt.target).is(megaMenu) && !$(evt.target).is(that)){
						megaMenu.trigger('display:hide');

						if(!$(evt.target).next('.mega-menu').length){
							$('#backdrop').trigger('display:hide');
						}
					}
				});
			}
		});
	});

	$('nav[role=navigation] ul ul a').focus(function(){
		var that = $(this);

		that.closest('ul').prev('a').addClass('child-has-focus');
	}).blur(function(){
		var that = $(this);

		that.closest('ul').prev('a').removeClass('child-has-focus');
	});

	/**
	 * The actions for the button that shows/hides the menu on mobile.
	 * TODO Find a better way to apply the no-scroll class to the body. i dont like doing it based on a number. or at least a static number
	 */
	$('#burger, .close-sidebar').click(function(e){
		e.preventDefault();
		$('#burger, nav#main-navigation').toggleClass('show');
		app.head.toggleClass('menu-open');
		$('nav#main-navigation').css({'top': app.headHeight, 'height': win.innerHeight() - app.headHeight});

		$('nav#main-navigation .menu-item span').removeClass('open');

		if(win.outerWidth() <= app.mediaBreaks.phone){
			// $('body').toggleClass('no-scroll');
		}

		if($('nav#main-navigation').hasClass('show')){
			win.on('click', function(evt){
				if(!$(evt.target).parents().is('#main-header') && !$(evt.target).is('#burger')){
					$('#burger, nav#main-navigation').removeClass('show');
					app.head.removeClass('menu-open');
					$('nav#main-navigation .menu-item span').removeClass('open');
					// $('body').removeClass('no-scroll');
					win.off('click');
				}
			});
		}
	});

	/**
	 * Just a thing to make the window scroll
	 */
	app.scrollToTop.click(function(e){
		scrollTo('html');
	});

	/**
	 * Grabs all the hash links and runs the scrollTo function
	 */
	$('a[href*="#"]').click(function(e){
		if(location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname){
			e.preventDefault();
			scrollTo(this.hash);
			$(this.hash).attr('tabindex', '-1').focus().blur().removeAttr('tabindex');
		}
	});

	/**
	 * Shows and hides FAQ content on all pages that use the shortcode
	 */
	$('.faq-slide-content h4').click(function(e){
		var that = $(this),
			hasClass = that.nextAll('div').hasClass('open');

		$('.faq-slide-content div').removeClass('open');

		if(!hasClass){
			setTimeout(function(){
				that.nextAll('div').addClass('open');
			}, 301);
		}
	});

	$('.copy-link').click(function(e){
		e.preventDefault();
		var that = $(this),
			temp = $('<input style="height: 0; overflow: hidden;">'),
			text = $('<span class="link-copied">' + __('Link Copied!', 'halekulani_domain') + '</span>');

		$('body').append(temp);
		temp.val($(this).attr('href')).select();
		document.execCommand('copy');
		temp.remove();
		that.append(text);

		setTimeout(function(){
			text.remove();
		}, 2000);
	});

	/**
	 * format phone numbers on input blur
	 * @return {[type]} [description]
	 */
	$('input[type="tel"]').blur(function(){
		$(this).val(app.formatPhoneNumber($(this).val()));
	});

	/**
	 * Attach calendars to all inputs of type "date"
	 */
	// $('input[type="date"]').each(function(){
	// 	var that = $(this),
	// 		date = app.calendar({
	// 			element: app.createCal(),
	// 			on_select: function(newDate){
	// 				that.val(function(){
	// 					return newDate.getFullYear() + '-' + pad(newDate.getMonth() + 1, 2) + '-' + pad(newDate.getDate(), 2);
	// 				});
	// 				that.addClass('hasValue');
	// 				that.nextAll('.clear-input').click(function(e){
	// 					that.val('');
	// 					that.removeClass('hasValue');
	// 					date.element.removeClass('show');
	// 				});
	// 				date.element.removeClass('show');
	// 			},
	// 			is_valid: function(date){
	// 				return date.getTime() > new Date().getTime();
	// 			}
	// 		});
	//
	// 	that.parent().append(date.element).click(function(e){
	// 		if(e.target === that[0]){
	// 			$('.calendar').removeClass('show');
	// 			that.siblings(date.element).addClass('show');
	// 			win.on('click', date.close);
	// 		}
	// 	});
	// });

	(function(){
		if(!$('#banner-video').length) return;

		var player = new Vimeo.Player($('#banner-video')[0]);

		$('.video-control').click(function(){
			var that = $(this);

			player.getPaused().then(function(paused){
				if(paused){
					player.play();
					that.text($('<textarea />').html('&#xe82b;').text());
				}else{
					player.pause();
					that.text($('<textarea />').html('&#xe841;').text());
				}
			});
		});
	})();

	/**
	 * move the sidebar and parallaxes on page load in case the window isnt at the top
	 */
	if(typeof app.moveSidebar === 'function') app.moveSidebar();

	if(win.scrollTop() >= app.head.offset().top + app.head.outerHeight()){
		app.scrollToTop.addClass('show');
	}

	/**
	 * Adds scrollEvent function to various event listeners.
	 * This was done to make sure all scrolling events (ie touch, scroll, etc) are in passive mode.
	 */
	for(var ni = 0; ni < app.movementEvents.length; ++ni){
		document.addEventListener(app.movementEvents[ni], app.scrollEvent, {passive: true});
	}

	window.addEventListener('resize', debounce(app.resizeEvent, 300), {passive: true});

	$('.form-builder').submit(app.validateForm(function(that, errors){
		if(errors.length < 1){
			var opts = urlParams(that.serialize()),
				data = {},
				formData = new FormData(that[0]),
				item;

			that.find('input[type="file"]').each(function(){
				var fileInput = $(this),
					file = fileInput[0].files[0];

				formData.append(fileInput.attr('name'), file);
			});

			formData.append('action', 'submit_form_builder');
			data.fields = {};

			for(item in opts){
				if(item === 'form_id'){
					data[item] = opts[item];
				}else{
					data.fields[item] = opts[item];
				}
			}

			that.find('[type="submit"]').attr('disabled', true);

			$.ajax({
				type: 'POST',
				url: app.ajaxUrl,
				data: formData,
				processData: false,
				contentType: false,
				success: function(data){
					if(parseInt(data, 10) !== 0){
						if(data.status > 0){
							app.notification(__('Form Submitted!'), 'success');
							that.html('<h2 class="text-center">Form Submitted Successfully!</h2>');
						}else{
							app.notification(data.errors, 'error');
							that.find('[type="submit"]').attr('disabled', false);
						}
					}else{
						app.notification(__('Internal error. Please try again.', 'halekulani_domain'), 'error');
						that.find('[type="submit"]').attr('disabled', false);
					}

					return data !== 0;
				}
			});
		}
	}));

	$('.offsite-form').submit(app.validateForm(function(that, errors){
		var formData = urlParams(that.serialize()),
			message = that.find('meta[name="form-success-message"]').attr('content') || __('Form Submitted Successfully!'),
			data;

		formData.formId = that.data('id');
		data = {
			action: 'submit_offsite_form',
			data: formData
		};

		/**
		 * [doAjax description]
		 * @return {[type]} [description]
		 */
		function doAjax(){
			$.ajax({
				type: 'POST',
				url: app.ajaxUrl,
				data: data,
				success: function(resp){
					if(parseInt(resp, 10) !== 0){
						if(resp.status > 0){
							app.notification(__('Form Submitted!'), 'success');
							that.html('<h2 class="col-xs text-center">' + message + '</h2>');
						}else{
							app.notification(resp.errors, 'error');
							that.find('[type="submit"]').attr('disabled', false);
						}
					}else{
						app.notification(__('Internal error. Please try again.', 'halekulani_domain'), 'error');
						that.find('[type="submit"]').attr('disabled', false);
					}

					return resp !== 0;
				}
			});
		}

		if(errors.length < 1){
			doAjax();
		}
	}));

	$("a[href*='synxis.com']").each(function(){
		var bookingLink = $(this);
		var bookhref = bookingLink.attr('href');

		bookingLink.attr('href', AppendNavisKeywordToURL(bookhref));
	});

	NavisSetHiddenKeywordFieldD('navis-input', 'organic');

	(function(){
		var phoneElements = document.getElementsByClassName('navis-number');
		var navisTFNraw = NavisConvertTagToPhoneNumberBasic(ReadNavisTagCookie());
		var navisTFNdisp = FormatPhone(navisTFNraw, '(###) ###-####');
		var navisTFNhref = FormatPhone(navisTFNraw, '###-###-####');
		var ni;

		for(ni = phoneElements.length - 1; ni >= 0; --ni){
			phoneElements[ni].href = 'tel:+1-' + navisTFNhref;
			phoneElements[ni].innerHTML = navisTFNdisp;
		}
	})();
});

/**
 * Hide the fullscreen loader. This happens at window.load so we can wait for all images to load too
 */
$(window).on('load', function(){
	app.observeIntersections();
	setTimeout(function(){
		$('#fullscreen-loading').remove();
		if(typeof app.afterLoad === 'function'){
			app.afterLoad();
		}
	}, 301);

	setTimeout(function(){
		$('.parallax').each(function(){
			var that = $(this),
				height = that.height(),
				top = that.offset().top,
				img = document.createElement('img');

			img.src = that.css('background-image').replace(/url\(['|"]?(.*[^'|"])['|"]?\)/, '$1');
			that[0].top = top;
			that[0].bottom = top + height;
			that[0].center = that[0].style.backgroundPositionY ? (parseInt(that[0].style.backgroundPositionY) / 100) * height : height / 2;
			img.onload = function(){
				that[0].amount = that.height() / win.height();
				app.moveParallax(that);
			};
		});
	}, 100);
});
